import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import About from "../../components/about/about";
import Quote3 from "../../components/quote3/quote3";
import VideoSection from "../../components/VideoSection";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import RsvpSectionS3 from "../../components/RsvpSectionS3/RsvpSectionS3";
import Testimonial from "../../components/Testimonial/Testimonial";
import TeamSection from "../../components/TeamSection/TeamSection";
import PricingSection from "../../components/PricingSection/PricingSection";
import FunFact from "../../components/FunFact/FunFact";
import PartnerSection from "../../components/PartnerSection";

const AboutPage: React.FC = () => {
  return (
    <Fragment>
      <Navbar hclass="wpo-header-style-1" />
      <PageTitle pageTitle="About Us" pagesub="About" />
      <About aClass="style-2 section-padding pb-0" />
      <Quote3 />
      <VideoSection />
      <ServiceSection />
      <ProjectSection />
      <RsvpSectionS3 />
      <Testimonial />
      <TeamSection />
      <PricingSection />
      <FunFact />
      <PartnerSection />
      <Footer footerClass="wpo-site-footer-s1" />
      <Scrollbar />
    </Fragment>
  );
};

export default AboutPage;
